import common from "./common";
import { showNotify } from "vant";
export default {
  mixins: [common],
  data() {
    return {
      imgpath: {},
      lightpath: {
        delete: require("./images/delete_pc2.png"),
        user: require("./images/user2.png"),
        feedback: require("./images/feedback2.png"),
        logo: require("./images/logo_pc.png"),
        beta: require("./images/beta_h5_l.png"),
        open: require("./images/open_h5_l.png"),
        edit: require("./images/editIcon_Pc2.png"),
        robot: require("./images/robot.png"),
        send: require("./images/sendPc.png"),
        refresh: require("./images/refresh.png"),
        copy: require("./images/copy_h5_l.png"),
        like: require("./images/like_h5_l.png"),
        unlike: require("./images/unlike_h5_l.png")
      },
      darkpath: {
        delete: require("./images/delete_h5.png"),
        user: require("./images/user.png"),
        feedback: require("./images/feedback.png"),
        logo: require("./images/logo_h5.png"),
        beta: require("./images/beta_h5.png"),
        open: require("./images/open_h5.png"),
        edit: require("./images/editIcon_Pc.png"),
        robot: require("./images/robot.png"),
        send: require("./images/sendPc.png"),
        refresh: require("./images/refreshtn_pc.png"),
        copy: require("./images/copy_h5_d.png"),
        like: require("./images/like_h5_d.png"),
        unlike: require("./images/unlike_h5_d.png")
      }
    };
  },
  created() {
    this.imgpath = {
      ...this.darkpath
    };
    const root = document.querySelector(":root");
    root.style.setProperty("--text-color", "#fff");
    root.style.setProperty("--gray-color", "rgb(121, 133, 142)");
    root.style.setProperty("--accent-color", "#4892E7");
    root.style.setProperty("--accent-color-light", "#A3EEFF");
    root.style.setProperty("--primary-color", "#263c4aff");
    root.style.setProperty("--secondary-color", "#132c3bff");
  },
  watch: {
    isLightTheme(val) {
      const root = document.querySelector(":root");
      root.style.setProperty("--text-color", val ? "#2F5883" : "#fff");
      root.style.setProperty("--gray-color", val ? "#4892E7" : "rgb(121, 133, 142)");
      root.style.setProperty("--accent-color", val ? "#4892E7" : "#4892E7");
      root.style.setProperty("--accent-color-light", val ? "#A3EEFF" : "#A3EEFF");
      this.imgpath = val ? this.lightpath : this.darkpath;
    }
  },
  methods: {
    copy(text) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        showNotify({
          message: "复制成功",
          type: "primary"
        });
      }
      document.body.removeChild(input);
    },
    like() {
      showNotify({
        message: "感谢您的喜欢",
        type: "primary"
      });
    },
    unlike() {
      showNotify({
        message: "感谢您的反馈",
        type: "primary"
      });
    },
    handleDelete(item) {
      showNotify({
        message: "点击了删除",
        type: "primary"
      });
      console.log(item);
    }
  }
};